<ul class="nav nav-tabs" id="contactTabs" role="tablist">
    <li class="nav-item" role="presentation">
        <a class="nav-link" id="contact-find-link" data-toggle="tab" data-target="#contact-find" type="button" role="tab" aria-controls="home" aria-selected="false"><span class="mdi mdi-magnify"></span> Find</a>
    </li>
    <li class="nav-item" role="presentation">
        <a class="nav-link" id="contact-add-link" data-toggle="tab" data-target="#contact-add" type="button" role="tab" aria-controls="profile" aria-selected="false"><span class="uil-plus"></span> New Contact</a>
    </li>
</ul>

<div class="tab-content" id="contactTabContent">

    <div class="tab-pane fade" id="contact-find" role="tabpanel" aria-labelledby="find-tab">
        <div class="card">
            <div class="card-header">
                <form [formGroup]="form">
                    <div class="input-group">
                        <input autocomplete="off" type="search" class="form-control" id="search" autofocus="true" formControlName="inquiry" placeholder="{{ words[language]['typeToFilterOut'] }}">
                        <div class="input-group-append">
                            <span class="input-group-text"><span class="mdi mdi-magnify search-icon"></span></span>
                        </div>
                    </div>
                </form>
            </div>
            <div class="card-body">

                <div id="listing" class="col-md-12" (scroll)="scrolled($event)">
                    @if (contacts) {
                        <table class="table table-sm table-hover table-striped" id="contactTable">
                            <thead>
                                <tr>
                                    <th (click)="sort('name')" class="sorted" scope="col">
                                        {{ words[language]['name'] }}
                                        @if (sortedAsc('name')) {
                                            <span class="dripicons-chevron-up text-dark sort-icon"></span>
                                        }
                                        @if (sortedDesc('name')) {
                                            <span class="dripicons-chevron-down text-dark sort-icon"></span>
                                        }
                                    </th>
                                    <th scope="col">{{ words[language]['phone'] }}</th>
                                    <th scope="col">{{ words[language]['roles'] }}</th>
                                    <th scope="col">{{ words[language]['createdAt'] }}</th>
                                    <th scope="col">{{ words[language]['location'] }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (contact of contacts; track contact) {
                                <tr class="clickable text-dark">
                                    <th scope="row" (click)="contactSelected(contact.id)" data-dismiss="modal" data-toggle="modal">{{contact.name}}</th>
                                    <td><a href="tel:{{contact.phone}}" (click)="$event.stopPropagation()">{{contact.phone | phone}}</a></td>
                                    <td>{{contact.roles}}</td>
                                    <td (click)="contactSelected(contact.id)" data-dismiss="modal" data-toggle="modal">
                                        {{contact.createdAt | date:'shortDate'}}</td>
                                    <td (click)="contactSelected(contact.id)" data-dismiss="modal" data-toggle="modal">
                                        {{contact.city}}, {{contact.state}} {{contact.zipCode}}</td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    }
                </div>
                <p class="list-footer text-muted">{{displayed | number: '1.0-0'}} / {{records | number: '1.0-0'}}
                    {{words[language]['displayed']}}</p>
            </div>
        </div>
    </div>

    <div class="tab-pane fade" id="contact-add" role="tabpanel" aria-labelledby="add-tab">
        <div class="card">
            <div class="card-header text-right">
                <button class="btn btn-sm btn-primary" (click)="saveContact()" [disabled]="saleBuyerInformation.invalid">Save and Use</button>
            </div>
            <div class="card-body">
                <form [formGroup]="saleBuyerInformation">
                    <div class="form-row">
                        <div class="form-group col-sm-12 col-md-4">
                            <label for="buyerTypeId">Buyer Type</label>
                            <select class="custom-select text-dark" [(ngModel)]="buyerTypeId" [ngModelOptions]="{standalone: true}" (change)="updateIsIndividual($event)">
                                @for (type of buyerTypes; track type) {
                                    <option [value]="type.id"> {{words[language][ type.name ] }}</option>
                                }
                            </select>
                        </div>
                        <div class="form-group col-sm-12 col-md-4">
                            <label [ngClass]="{'d-none': isIndividual}">EIN</label>
                            <label [ngClass]="{'d-none': !isIndividual}">Social Security Number</label>
                            <input class="form-control text-dark" type="text" id="taxPayerNumber" formControlName="taxPayerNumber" autocomplete="off">
                        </div>
                    </div>
                    <div class="form-row" [ngClass]="{'d-none': isIndividual}">
                        <div class="form-group col">
                            <label for="companyName">Company Name</label>
                            <input class="form-control text-dark" type="text" id="companyName" formControlName="companyName" autocomplete="off">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-5 col-sm-12">
                            <label for="firstName">First Name</label>
                            <input class="form-control text-dark" type="text" id="firstName" formControlName="firstName" autocomplete="off">
                        </div>
                        <div class="form-group col-md-2 col-sm-12">
                            <label for="middleName">Middle Name</label>
                            <input class="form-control text-dark" type="text" id="middleName" formControlName="middleName" autocomplete="off">
                        </div>
                        <div class="form-group col-md-5 col-sm-12">
                            <label for="lastName">Last Name</label>
                            <input class="form-control text-dark" type="text" id="lastName" formControlName="lastName" autocomplete="off">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6 col-sm-12">
                            <label for="address">Address</label>
                            <input class="form-control text-dark" type="text" id="address" formControlName="address" autocomplete="off">
                        </div>
                        <div class="form-group col-md-6 col-sm-12">
                            <label for="address2">Address 2</label>
                            <input class="form-control text-dark" type="text" id="address2" formControlName="address2" autocomplete="off">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-3 col-sm-12">
                            <datalist id="zip-codes">
                                @for (address of zipCodeList; track address) {
                                    <option (click)="selectZipCode(address)" [value]="address.zipcode">{{address.zipcode}}, {{address.city}}</option>
                                }
                            </datalist>

                            <label for="zipCode">{{ words[language]['zipcode'] }}</label>
                            <div class="position-relative hover-list">
                                <input class="form-control" type="text" id="zipCode_new" formControlName="zipCode" (keyup)="searchZipCode()" list="zip-codes" autocomplete="off">
                            </div>
                        </div>
                        <div class="form-group col-md-4 col-sm-12">
                            <label for="county">County</label>
                            <input class="form-control text-dark" type="text" id="county" formControlName="county" autocomplete="off">
                        </div>
                        <div class="form-group col-md-4 col-sm-12">
                            <label for="city">City</label>
                            <input class="form-control text-dark" type="text" id="city" formControlName="city" autocomplete="off">
                        </div>
                        <div class="form-group col-md-1 col-sm-12">
                            <label for="state">State</label>
                            <input class="form-control text-dark" type="text" id="state" formControlName="state" autocomplete="off">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6 col-sm-12">
                            <label for="phoneNumber">Phone Number</label>
                            <input class="form-control text-dark" type="text" id="phoneNumber" formControlName="phoneNumber" autocomplete="off">
                        </div>
                        <div class="form-group col-md-6 col-sm-12">
                            <label for="emailAddress">Email Address</label>
                            <input class="form-control text-dark" type="text" id="city" formControlName="emailAddress" autocomplete="off">
                        </div>
                    </div>
                    <div class="form-row" [ngClass]="{'d-none': !isIndividual}">
                        <div class="form-group col-md-3 col-sm-12">
                            <label for="identificationTypeId">ID Type</label>
                            <select class="custom-select" id="identificationTypeId" formControlName="identificationTypeId">
                                @for (type of types; track type) {
                                    <option [value]="type.id">{{type.type}}</option>
                                }
                            </select>
                        </div>
                        <div class="form-group col-md-3 col-sm-12">
                            <label for="number">ID Number</label>
                            <input class="form-control text-dark" type="text" id="number" formControlName="number" autocomplete="off">
                        </div>
                        <div class="form-group col-md-3 col-sm-12">
                            <label for="issuer">ID Issuer</label>
                            <select id="issuer" class="form-control" formControlName="issuer">
                                @for (issuer of issuers; track issuer) {
                                    <option [value]="issuer.abbreviation">{{issuer.name}}</option>
                                }
                            </select>
                        </div>
                        <div class="form-group col-md-3 col-sm-12">
                            <label for="expirationDate">ID Expiry Date</label>
                            <input class="form-control text-dark" type="date" id="expirationDate" formControlName="expirationDate" autocomplete="off">
                        </div>
                    </div>
                </form>
            </div>
            <div class="card-footer text-right">
                <button class="btn btn-sm btn-primary" (click)="saveContact()" [disabled]="saleBuyerInformation.invalid">Save and Use</button>
            </div>
        </div>
    </div>

</div>